<template>
	<div>
		<v-toolbar color = "blue-grey lighten-5" class = "index-topbar">
			<v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-fine.png" alt = "music x lab logo" class = "logo"/>
			</v-hover>
      <div style="width: 30px"></div>
			<v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-nyu.png" alt = "music x lab logo" class = "logonyu"/>
			</v-hover>
      <div style="width: 30px"></div>
      <v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-mbzuai.png" alt = "mbzuai logo" class = "logombz"/>
			</v-hover>
    		<!-- <v-toolbar-title>Music X Lab</v-toolbar-title> -->
    		<v-spacer></v-spacer>
    		<v-toolbar-items   style="font-family:'Breve Display';">
      			<v-btn flat :color= "this.$color.primary" style="font-size:1.2rem;font-weight:200; " @click =" $router.push({path:'/index'})">Home</v-btn>
      			<v-btn flat :color= "this.$color.primary" style="font-size:1.2rem;"  @click ="$router.push({path:'/people'})">People</v-btn>
				<v-menu offset-y open-on-hover>
					<template v-slot:activator = "{on}">
        				<v-btn color= "#657C88" flat v-on = "on" style="font-size:1.2rem;" @click ="$router.push({path:'/groups'})">Groups</v-btn>
					</template>
      				<v-list>
        				<v-list-tile v-for="(item, index) in groupInfo" :key = "index" @click="$router.push({name:'Groups',params:{logan:item.logan}})" >
          					<v-list-tile-title>
								{{ item.name }}
							</v-list-tile-title>
        				</v-list-tile>
      				</v-list>
				</v-menu>
				<v-menu offset-y open-on-hover>
					<template v-slot:activator = "{on}">
        				<v-btn color= "#657C88" flat v-on = "on" style="font-size:1.2rem;">Demos</v-btn>
					</template>
      				<v-list>
        				<v-list-tile v-for="(item, dindex) in demoInfo" :key = "dindex" @click="$router.push({path: item.address})" >
          					<v-list-tile-title >
								{{ item.name }}
							</v-list-tile-title>
        				</v-list-tile>
                        <v-list-tile flat @click="switchToPage('https://www.cs.cmu.edu/~gxia/demo.html')"><v-list-tile-title >Other Demos</v-list-tile-title></v-list-tile>
      				</v-list>
                    
				</v-menu>
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" $router.push({path:'/publications'})">Publications</v-btn>
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" switchToPage('http://blog.musicxlab.com/') ">Blog</v-btn>
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" switchToPage('https://github.com/music-x-lab/music-x-lab') ">Github</v-btn>
				<!-- <v-btn flat>News</v-btn> -->
    		</v-toolbar-items>
  		</v-toolbar>
		<v-layout row wrap style = "background:url('https://i.postimg.cc/NGps0dqN/headline.png');" class = "elevation-1">
            <v-flex xs12 class="text-xs-center pt-4 ">
                <div class = "mb-2" :style = "{color:this.$color.primary,fontSize:5.0 + 'rem',fontFamily:'Calluns !important'}">Our Teams</div>
                <div class = "display-1 mb-4" style="color:grey">闻道有先后 术业有专攻</div>
            </v-flex>
        </v-layout>
        
        <v-layout row wrap class = "pt-5" >
            <v-flex xs2></v-flex>
            <v-flex xs8>
                <v-timeline dense>
                    <template v-for="(group,index) in groupInfo">
                        <v-timeline-item :key="index" :color="group.logan" large right :id="group.logan">
                            <v-card class="elevation-2" >
                                <div>
                                    <v-layout align-center fill-height class = "py-2">        
                                        <v-flex xs5 >
                                            <v-img :src="group.picture"  height="400px" class="ml-3" lazy contain>
                                                <template v-slot:placeholder>
                                                    <v-layout fill-height align-center justify-center ma-0>
                                                        <v-progress-circular indeterminate :color="group.logan"></v-progress-circular>
                                                    </v-layout>
                                                </template>
                                            </v-img>
                                        </v-flex>
                                        <v-flex class="px-5" xs7 >
                                            <div class="text-xs-center my-2" :style="{color:$color.primary,fontFamily:'ProximaNova !important',fontSize:group.name.length > 35 ? '2.0rem':'2.3rem'}">{{group.name}}</div>
                                            <div class="text-xs-center my-2" :style="{color:$color.primary,fontFamily:'BenMo !important',fontSize:'1.9rem'}">{{group.intro}}</div>

                                            <v-divider></v-divider>
                                            <div class="text-xs-left my-2 scroll-y" style="font-size:1.3rem;max-height:30vh;font-family:ProximaNova">{{group.description}}</div>
                                            <v-divider class = "mb-3"></v-divider>
                                            <v-layout row left>
                                                <div style="text-align:left;">
                                                    <v-chip class = "text-xs-left" outline :color="$color.activate" v-for="(keyword,kk_id) in group.keywords" :key="kk_id">
                                                        <strong>{{ keyword }}</strong>&nbsp;
                                                    </v-chip>
                                                </div>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </div>
                                <div>
                                    <v-layout>
                                        <v-btn flat style="font-size:2.0rem !important;">
                                            <v-icon left style="font-size:2.5rem !important;">people</v-icon>Members
                                        </v-btn>
                                    </v-layout>
                                    <v-divider ></v-divider>
                                     <v-layout>
                                        <div class="avatar-scrolling ma-4 scroll-x">
                                            <div justify-center column v-for="(a_item,a_index) in group.members" class="mx-3 avatar-el text-xs-center" :key="a_index" >
                                                <v-avatar  size="10vh" color="grey lighten-4" >
                                                    <v-img :src="a_item.picture == '' ? 'https://i.postimg.cc/GpKN1pgY/2.jpg' : a_item.picture " alt="avatar">
                                                        <template v-slot:placeholder>
                                                            <v-layout fill-height align-center justify-center ma-0>
                                                                <v-progress-circular indeterminate color="purple"></v-progress-circular>
                                                            </v-layout>
                                                        </template>
                                                    </v-img>
                                                </v-avatar>
                                                <div class = "avatar-el my-2">
                                                    {{a_item.name}}
                                                </div>
                                            </div>
                                        </div>
                                    </v-layout>
                                </div>
                            </v-card>
                           
                        </v-timeline-item>
                    </template>
                </v-timeline>

            </v-flex>
            <v-flex xs2></v-flex>
        </v-layout>

	</div>
</template>

<script>
export default {
  name: 'Groups',
  data() {
    return {
		groupInfo:[{name:"",logan:"red",members:[{name:"",picture:""}],picture:"",publications:[],keywords:[],id:0,intro:"",description:""}],
		people:[{name:"Gus Xia",avatar:"https://i.postimg.cc/Nj1SpD1d/1.jpg",link:"http://www.baidu.com"},
                {name:"Ziyu Wang",avatar:"https://i.postimg.cc/GpKN1pgY/2.jpg",link:"http://www.baidu.com"},
                {name:"Yiyi Zhang",avatar:"https://i.postimg.cc/hjGY4qNY/3.jpg",link:"http://www.baidu.com"},
                {name:"Ruihan Yang",avatar:"https://i.postimg.cc/J4JRCbNk/4.jpg",link:"http://www.baidu.com"},
                {name:"Junyan Jiang",avatar:"https://i.postimg.cc/ZYXJQfdm/5.jpg",link:"http://www.baidu.com"},
                {name:"Ke Chen",avatar:"https://i.postimg.cc/MHC3YfXk/6.jpg",link:"http://www.baidu.com"},
                {name:"Yixiao Zhang",avatar:"https://i.postimg.cc/BZjqMWtN/7.jpg",link:"http://www.baidu.com"},
                {name:"houze Liu",avatar:"https://i.postimg.cc/0QHBbBsy/8.jpg",link:"http://www.baidu.com"},
                {name:"Dingsu Wang",avatar:"https://i.postimg.cc/nrjw7GFY/9.jpg",link:"http://www.baidu.com"},
                {name:"Tianyao Chen",avatar:"https://i.postimg.cc/T36fdp0H/10.jpg",link:"http://www.baidu.com"},
                {name:"Ruitang Chen",avatar:"https://i.postimg.cc/jS4KLtkq/11.jpg",link:"http://www.baidu.com"},
                {name:"Xianbin Gu",avatar:"https://i.postimg.cc/1zWQrMQL/12.jpg",link:"http://www.baidu.com"},
                {name:"Yian Zhang",avatar:"https://i.postimg.cc/Rhtx9BHB/13.jpg",link:"http://www.baidu.com"}
                ],
        tempLogan:undefined,
        demoInfo:[
            {name:"Interactive Rainbow Score", address:"/demo/IRS"}
        ]

    }
  },
  mounted() {
      this.getRouterData()
      this.getGroupsInfo()
  },
  props: {
    msg: String
  },
  methods: {
    getRouterData:function() {
        this.tempLogan = this.$route.params.logan
        console.log(this.tempLogan)
    },
    getGroupsInfo:async function() {
        let that = this
        await this.$axios.get("/group/id/list").then(function(res) {
            console.log(res)
            let resdata = res.data
            that.groupInfo = []
            for(let i in resdata) {
                let temp = resdata[i]
                temp.logan = resdata[i].color
                that.groupInfo.push(temp)
            }
           
        }).catch(function(error) {
            console.log(error)
        })
        if(typeof(that.tempLogan) != undefined) {
            this.$vuetify.goTo('#' + that.tempLogan)
        }
    },
    switchToPage:function(url) {
		window.location.href=url
	},
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.test-class {
    height:auto !important;
}
.limit__height__class .v-list__tile {
    height: auto !important;
}
.limit-logan-offset .v-tooltip__content {
    top:1px !important;
}

.scroll-y { 
    -ms-overflow-style:none;
}
.scroll-y:hover { 
    -ms-overflow-style:-ms-autohiding-scrollbar;
}
.scroll-y::-webkit-scrollbar { 
    width: 0.5vw;
    height: 1px;
    display: none;
}
.scroll-y:hover::-webkit-scrollbar { 
    display: flex;
}
.scroll-y::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px #657C88;
    background:#657C88;
}


.avatar-scrolling {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style:none;
    scrollbar-face-color: #657C88;
    transition: all 0.5s;
}
.avatar-scrolling:hover {
    /* opacity: 1; */
    -ms-overflow-style:-ms-autohiding-scrollbar;
    transition: all 0.5s;
}
.avatar-scrolling::-webkit-scrollbar {
    width: 0;
    height: 0;
} 
.avatar-scrolling:hover::-webkit-scrollbar {
    width: 1px;
    height: 0.5vh; 
} 
.avatar-scrolling::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 5px #657C88;
    background:#657C88;
}
.avatar-el {
    display:flex;
    flex-flow:column;
}
</style>
